import apFb1 from "./ApFeedback1.png";
import apFb2 from "./ApFeedback2.png";
import apFb3 from "./ApFeedback3.png";
import apFb4 from "./ApFeedback4.png";
import apFb5 from "./ApFeedback5.png";


const certificates = [apFb1, apFb2, apFb3, apFb4, apFb5,];
export default certificates;
